module.exports = __webpack_public_path__ + "img/logo-m2n.c9c0c842.svg";